import { BancoDoBrasilMedium } from '../assets/banks/banco-do-brasil-medium'
import { BancoDoBrasilSmall } from '../assets/banks/banco-do-brasil-small'
import { BradescoMedium } from '../assets/banks/bradesco-medium'
import { BradescoSmall } from '../assets/banks/bradesco-small'
import { C6BankMedium } from '../assets/banks/c6bank-medium'
import { C6BankSmall } from '../assets/banks/c6bank-small'
import { CaixaMedium } from '../assets/banks/caixa-medium'
import { CaixaSmall } from '../assets/banks/caixa-small'
import { ItauMedium } from '../assets/banks/itau-medium'
import { ItauSmall } from '../assets/banks/itau-small'
import { NubankMedium } from '../assets/banks/nubank-medium'
import { NubankSmall } from '../assets/banks/nubank-small'
import { SantanderMedium } from '../assets/banks/santander-medium'
import { SantanderSmall } from '../assets/banks/santander.small'
import { UndefinedMedium } from '../assets/banks/undefined-medium'
import { UndefinedSmall } from '../assets/banks/undefined-small'
import type { BankFlagsProps } from '../flags.types'

const BankFlags = (props: BankFlagsProps) => {
  if (!props.variant)
    return props.size === 'sm' ? <UndefinedSmall /> : <UndefinedMedium />

  if (props.size === 'sm')
    switch (props.variant) {
      case 'banco-do-brasil':
        return <BancoDoBrasilSmall />
      case 'bradesco':
        return <BradescoSmall />
      case 'caixa':
        return <CaixaSmall />
      case 'c6bank':
        return <C6BankSmall />
      case 'itau':
        return <ItauSmall />
      case 'nubank':
        return <NubankSmall />
      case 'santander':
        return <SantanderSmall />
    }

  switch (props.variant) {
    case 'banco-do-brasil':
      return <BancoDoBrasilMedium />
    case 'bradesco':
      return <BradescoMedium />
    case 'caixa':
      return <CaixaMedium />
    case 'c6bank':
      return <C6BankMedium />
    case 'itau':
      return <ItauMedium />
    case 'nubank':
      return <NubankMedium />
    case 'santander':
      return <SantanderMedium />
  }
}

export default BankFlags
